var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpcomingPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.22729 1.85355C7.6415 1.26777 6.69175 1.26777 6.10597 1.85355L1.52018 6.43934C0.934393 7.02513 0.934393 7.97487 1.52018 8.56066L6.10597 13.1464C6.69175 13.7322 7.6415 13.7322 8.22729 13.1464L12.8131 8.56066C13.3989 7.97487 13.3989 7.02513 12.8131 6.43934L8.22729 1.85355Z",
    fill: "#6F7985",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcomingPolygon);
export default __webpack_public_path__ + "static/media/upcomingPolygon.1603c3db9afb780004f6a4ab20b19c72.svg";
export { ForwardRef as ReactComponent };